import { computed } from 'vue';

/**
 * @description This composable checks if the browser supports the Web Share API and contains functionality to share.
 * @returns {webShareApiSupported, shareViaWebShare}
 *
 * @example
 * const { webShareApiSupported, shareViaWebShare } = useWebShare();
 *
 */
export default function useWebShare(): { webShareApiSupported: ComputedRef<boolean>; shareViaWebShare: (title: string, text: string) => void } {
  /**
   * @description This composable checks if the browser supports the Web Share API.
   */
  const webShareApiSupported = computed(() => {
    if (import.meta.client) {
      return !!navigator.share
    }
    return false
  });

  /**
   * @description This composable shares the current page via the Web Share API.
   */
  const shareViaWebShare = (title: string, text: string) => {
    const url = useRequestURL().href;
    navigator.share({
      title,
      text,
      url,
    });
  }

  return {
    webShareApiSupported,
    shareViaWebShare,
  }
}
